import { AfterViewInit, Component, Inject } from '@angular/core';

// HubSpot's forms script is loaded globally from index.jade
declare var hbspt: any;

@Component({
    standalone: false,
    selector: 'help',
    templateUrl: '../app/pages/help/help.view.html',
    styleUrls: ['../app/pages/help/help.style.css']
    })
export class Help implements AfterViewInit {

    constructor(@Inject('MySynchFactory') private MSF:any){ }

    ngAfterViewInit(): void {
        this.MSF.ready(() => {
            // hbspt finds its target in the live document, so wait until the view is rendered
            hbspt.forms.create({
                region: "na1",
                portalId: "4000146",
                formId: "de6fc623-5520-4aaf-bc48-fd7091ff7430",
                target: "#hubspotHelpForm"
            });
        });
    }
}
